module.exports = __webpack_public_path__ + "static/media/everdays-logo-white.dcd06d3c.svg";